<template>
  <v-dialog v-model="dialog" persistent max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">Create Course</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-text-field
                  label="Name*"
                  required
                  v-model="name"
                  :rules="nameRules"
                ></v-text-field>
                <v-autocomplete
                  :items="categories"
                  v-model="category"
                  label="Category"
                  :rules="categoryRules"
                ></v-autocomplete>
              </v-form>
            </v-col>
          </v-row>
        </v-container>
        <small>*indicates required field</small>
      </v-card-text>
      <v-card-actions class="pa-3 pt-0">
        <v-btn depressed color="grey white--text" @click="$emit('cancel')"
          >Cancel</v-btn
        >
        <v-spacer></v-spacer>
        <v-btn
          :disabled="!valid"
          depressed
          color="blue white--text"
          @click="$emit('finish', { name: name, category: category })"
          >Create and Edit</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    dialog() {
      this.valid = true;
      this.name = "";
      this.category = "";
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    }
  },
  data: () => ({
    valid: true,
    lazy: false,
    name: "",
    category: "",
    nameRules: [v => !!v || "Name is required"],
    categoryRules: [v => !!v || "The category is required"],
    categories: [
      "Art & Design",
      "Business",
      "Computer Science",
      "Data Science",
      "Education & Teaching",
      "Engineering",
      "Health & Medicine",
      "Humanities",
      "Mathematics",
      "Programming",
      "Science",
      "Social Sciences"
    ]
  })
};
</script>

<style></style>
